exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-modal[data-v-0f6d8e32] {\n  width: 90%;\n  margin-left: 5%;\n}\n@media screen and (min-width: 800px) {\n.filter-modal[data-v-0f6d8e32] {\n    top: 120%;\n    width: 35rem;\n    margin: 0;\n}\n}\n@media screen and (min-width: 1024px) {\n.filter-wrapper[data-v-0f6d8e32] {\n    width: max-content;\n}\n}\n", ""]);

// exports
